import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import TermsOfServiceDialog from './TermsOfServiceDialog';

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary'}}>
      {'Copyright © OrangeTrie'}
      &nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const [termsOpen, setTermsOpen] = React.useState(false);

  return (
    <Container
      maxWidth={'xl'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 4, sm: 8 },
        py: { xs: 8, sm: 10 },
        textAlign: { sm: 'center', md: 'left' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          pt: { xs: 4, sm: 8 },
          width: '100%',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Copyright />
        <Box
          sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'left',
              textAlign: { sm: 'left', md: 'left' },
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              <Link
                  href="mailto:orangetrie2@gmail.com"
                  underline="hover"
                  color="inherit"
              >
                  Contact Us
              </Link>
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            <Link
              component="button"
              type="button"
              underline="hover"
              color="inherit"
              onClick={() => setTermsOpen(true)}
            >
              Terms of Service
            </Link>
          </Typography>
        </Box>
      </Box>
      <TermsOfServiceDialog open={termsOpen} onClose={() => setTermsOpen(false)} />
    </Container>
  );
}